(() => {
 'use strict';
 if(window.RorilioBogo)return;
 const config={
  "packs": {
    "67965604757825": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Mocha",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604790593": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Mocha",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604823361": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Mocha",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604856129": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Mocha",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604888897": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Coffee",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604921665": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Coffee",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604954433": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Coffee",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965604987201": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Coffee",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605019969": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Autumn",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605052737": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Autumn",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605085505": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Autumn",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605118273": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Autumn",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605151041": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Cocoa",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605183809": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Cocoa",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605216577": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Cocoa",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67965605249345": {
      "id": 68033451360577,
      "count": 1,
      "colors": [
        "Cocoa",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "67976470036801": {
      "id": 68033451393345,
      "count": 1,
      "colors": [],
      "handle": "serum-pestanas",
      "parent": 15426240545089
    },
    "67978504929601": {
      "id": 68033451426113,
      "count": 1,
      "colors": [],
      "handle": "tonico-seda-peptidos-egf",
      "parent": 15426548597057
    },
    "67985993007425": {
      "id": 68033451458881,
      "count": 1,
      "colors": [],
      "handle": "mascarilla-nocturna-colageno",
      "parent": 15427344040257
    },
    "67985993040193": {
      "id": 68071333036353,
      "count": 2,
      "colors": [],
      "handle": "mascarilla-nocturna-colageno",
      "parent": 15427344040257
    },
    "67985993072961": {
      "id": 68071334412609,
      "count": 3,
      "colors": [],
      "handle": "mascarilla-nocturna-colageno",
      "parent": 15427344040257
    },
    "67989375320385": {
      "id": 68033451491649,
      "count": 1,
      "colors": [
        "Cocoa Nude",
        "Cocoa Nude"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375353153": {
      "id": 68033451491649,
      "count": 1,
      "colors": [
        "Cocoa Nude",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375385921": {
      "id": 68033451491649,
      "count": 1,
      "colors": [
        "Sweet Strawberry",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375418689": {
      "id": 68033451524417,
      "count": 2,
      "colors": [
        "Cocoa Nude",
        "Cocoa Nude",
        "Cocoa Nude",
        "Cocoa Nude"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375451457": {
      "id": 68033451524417,
      "count": 2,
      "colors": [
        "Cocoa Nude",
        "Cocoa Nude",
        "Cocoa Nude",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375484225": {
      "id": 68033451524417,
      "count": 2,
      "colors": [
        "Cocoa Nude",
        "Cocoa Nude",
        "Sweet Strawberry",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375516993": {
      "id": 68033451524417,
      "count": 2,
      "colors": [
        "Cocoa Nude",
        "Sweet Strawberry",
        "Sweet Strawberry",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "67989375549761": {
      "id": 68033451524417,
      "count": 2,
      "colors": [
        "Sweet Strawberry",
        "Sweet Strawberry",
        "Sweet Strawberry",
        "Sweet Strawberry"
      ],
      "handle": "tinte-labial-peel-off",
      "parent": 15427793977665
    },
    "68071418495297": {
      "id": 68071334543681,
      "count": 2,
      "colors": [],
      "handle": "serum-pestanas",
      "parent": 15426240545089
    },
    "68071418528065": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Mocha",
        "Mocha",
        "Mocha",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418560833": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Mocha",
        "Coffee",
        "Mocha",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418593601": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Mocha",
        "Autumn",
        "Mocha",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418626369": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Mocha",
        "Cocoa",
        "Mocha",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418659137": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Coffee",
        "Mocha",
        "Coffee",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418691905": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Coffee",
        "Coffee",
        "Coffee",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418724673": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Coffee",
        "Autumn",
        "Coffee",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418757441": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Coffee",
        "Cocoa",
        "Coffee",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418790209": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Autumn",
        "Mocha",
        "Autumn",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418822977": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Autumn",
        "Coffee",
        "Autumn",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418855745": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Autumn",
        "Autumn",
        "Autumn",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418888513": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Autumn",
        "Cocoa",
        "Autumn",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418921281": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Cocoa",
        "Mocha",
        "Cocoa",
        "Mocha"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418954049": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Cocoa",
        "Coffee",
        "Cocoa",
        "Coffee"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071418986817": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Cocoa",
        "Autumn",
        "Cocoa",
        "Autumn"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    },
    "68071419019585": {
      "id": 68071334871361,
      "count": 2,
      "colors": [
        "Cocoa",
        "Cocoa",
        "Cocoa",
        "Cocoa"
      ],
      "handle": "tinte-cejas-peel-off",
      "parent": 15425488814401
    }
  },
  "units": {
    "68033451360577": {
      "handle": "tinte-cejas-peel-off",
      "colors": [
        "Mocha",
        "Coffee",
        "Autumn",
        "Cocoa"
      ]
    },
    "68033451393345": {
      "handle": "serum-pestanas",
      "colors": []
    },
    "68033451426113": {
      "handle": "tonico-seda-peptidos-egf",
      "colors": []
    },
    "68033451458881": {
      "handle": "mascarilla-nocturna-colageno",
      "colors": []
    },
    "68033451491649": {
      "handle": "tinte-labial-peel-off",
      "colors": [
        "Cocoa Nude",
        "Sweet Strawberry"
      ]
    },
    "68033451524417": {
      "handle": "tinte-labial-peel-off",
      "colors": [
        "Cocoa Nude",
        "Sweet Strawberry"
      ]
    },
    "68071333036353": {
      "handle": "mascarilla-nocturna-colageno",
      "colors": []
    },
    "68071334412609": {
      "handle": "mascarilla-nocturna-colageno",
      "colors": []
    },
    "68071334543681": {
      "handle": "serum-pestanas",
      "colors": []
    },
    "68071334871361": {
      "handle": "tinte-cejas-peel-off",
      "colors": [
        "Mocha",
        "Coffee",
        "Autumn",
        "Cocoa"
      ]
    }
  }
};
 const root=()=>window.Shopify?.routes?.root||'/';
 const sections=()=>({sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname});
 const props=fd=>Object.fromEntries([...fd.entries()].filter(([k])=>/^properties\[.*\]$/.test(k)).map(([k,v])=>[k.slice(11,-1),v]));
 const expand=(id,quantity=1,properties={},form=null,offer=null)=>{
  const p=config.packs[id];if(!p)return null;
  let colors=[...p.colors];
  if(form&&p.handle==='tinte-labial-peel-off'){
   const node=form.closest('[data-lip-product]');const active=node?.querySelector('[data-pack].is-selected');
   const selected=active?[...active.querySelectorAll('select')].map(s=>s.value):[];
   if(selected.length===p.count*2)colors=selected;
  }
  if(form&&p.handle==='tinte-cejas-peel-off'){
   const card=document.querySelector('rorilio-brow-bundle .rb-pack.is-selected');
   const selected=card?[...card.querySelectorAll('select[data-tone]')].sort((x,y)=>x.dataset.tone-y.dataset.tone).map(s=>s.value):[];
   if(selected.length===p.count*2&&selected.every(c=>config.units[p.id].colors.includes(c)))colors=selected;
  }
  if(!form&&p.handle==='tinte-labial-peel-off'){
   const chosen=Array.from({length:p.count*2},(_,n)=>properties['Tono '+(n+1)]);
   if(chosen.every(c=>config.units[p.id].colors.includes(c)))colors=chosen;
  }
  const group=offer||('rr'+Date.now().toString(36)+Math.random().toString(36).slice(2,9));
  const base={...properties};Object.keys(base).forEach(k=>{if(/^Tono \d+$/.test(k)||k.startsWith('_rr_'))delete base[k];});
  return ['paid','gift'].map((role,i)=>({id:p.id,quantity:p.count*quantity,properties:{...base,_rr_bogo:'v1',_rr_offer:group,_rr_role:role,_rr_origin:p.handle,...Object.fromEntries(Array.from({length:p.count*quantity},(_,n)=>colors.slice(i*p.count,(i+1)*p.count)[n%p.count]).filter(Boolean).map((c,n)=>['Tono '+(n+1),c]))}}));
 };
 const prepare=fd=>{const items=expand(fd.get('id'),Number(fd.get('quantity'))||1,props(fd),fd._rrForm);return items?{items,...(fd.has('sections')?{sections:String(fd.get('sections')).split(','),sections_url:fd.get('sections_url')||location.pathname}:{})}:null;};
 window.RorilioBogo={prepare,expand,config};
 const read=async()=>{const r=await fetch(root()+'cart.js',{cache:'no-store'});if(!r.ok)throw Error('No se pudo consultar el carrito.');return r.json();};
 const post=async(path,body)=>{const r=await fetch(root()+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});const j=await r.json();if(!r.ok||j.status)throw Error(j.description||'No se pudo actualizar el carrito.');return j;};
 const render=async cart=>{
  if(!cart.sections){const r=await fetch(root()+'?sections=cart-drawer,cart-icon-bubble',{cache:'no-store'});if(!r.ok)throw Error('Actualiza el carrito para continuar.');cart.sections=await r.json();}
  const d=document.querySelector('cart-drawer');if(d){const open=d.classList.contains('active');d.renderContents(cart);if(!open)d.close();}
  if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'rr-bogo',cartData:cart});
  if(location.pathname.endsWith('/cart'))location.reload();
 };
 let busy=false;
 const error=message=>{let el=document.querySelector('#CartDrawer-CartErrors')||document.querySelector('#cart-errors');if(el){el.textContent=message;el.setAttribute('role','alert');}};
 // Paliers d'un même produit (ex. Cejas 1+1 / 2+2, hotfix 28/10) : une quantité changée au panier est recomposée en packs, gros packs d'abord (3 = 2+2 + 1+1), jamais au tarif unitaire du pack d'origine.
 const tiers=unit=>{const h=config.units[unit].handle,m=new Map();Object.values(config.packs).forEach(p=>{if(p.handle===h)m.set(p.id,p.count);});return [...m].sort((a,b)=>b[1]-a[1]);};
 const split=(unit,n)=>{const out=[];for(const [id,c] of tiers(unit)){const k=Math.floor(n/c);if(k){out.push([id,c*k]);n-=c*k;}}return n?null:out;};
 // Remplace tous les packs du produit (lines) par la composition parts ; tons repris dans l'ordre, ceux du groupe modifié d'abord.
 async function regroup(lines,parts,group,count){
  const tones=(role,own)=>{const out=[];lines.filter(l=>l.properties._rr_role===role&&(l.properties._rr_offer===group)===own).forEach(l=>{const n=own?count:l.quantity;for(let i=0;i<n;i++)out.push(l.properties['Tono '+(i%l.quantity+1)]||l.properties['Tono 1']);});return out.filter(Boolean);};
  const pt=[...tones('paid',true),...tones('paid',false)],gt=[...tones('gift',true),...tones('gift',false)];
  const base={...lines.find(l=>l.properties._rr_role==='paid').properties};Object.keys(base).forEach(k=>{if(/^Tono \d+$/.test(k))delete base[k];});
  const items=[];let off=0;
  for(const [id,q] of parts){
   const g='rr'+Date.now().toString(36)+Math.random().toString(36).slice(2,9),valid=config.units[id].colors;
   for(const [role,t] of [['paid',pt],['gift',gt]]){
    const p={...base,_rr_offer:g,_rr_role:role};
    if(valid.length)for(let n=0;n<q;n++){const c=t.length?t[(off+n)%t.length]:valid[0];p['Tono '+(n+1)]=valid.includes(c)?c:valid[0];}
    items.push({id:Number(id),quantity:q,properties:p});
   }
   off+=q;
  }
  await post('cart/add.js',{items});
  return post('cart/update.js',{updates:Object.fromEntries(lines.map(l=>[l.key,0])),...sections()});
 }
 async function updateOffer(group,count,role,tones){
  if(busy)return;busy=true;
  const checkout=document.querySelector('#CartDrawer-Checkout');checkout?.setAttribute('disabled','');
  try{
   const cart=await read(),lines=cart.items.filter(i=>i.properties?._rr_offer===group&&config.units[i.variant_id]);
   if(lines.length!==2||lines.some(l=>l.quantity!==lines[0].quantity))throw Error('El carrito ha cambiado. Recarga la página antes de continuar.');
   let result;
   if(tones){
    const line=lines.find(l=>l.properties._rr_role===role);if(!line)throw Error('Selección no disponible.');
    const valid=config.units[line.variant_id].colors;
    if(tones.length!==line.quantity||tones.some(t=>!valid.includes(t)))throw Error('Selecciona un tono disponible.');
    const properties={...line.properties};Object.keys(properties).forEach(k=>{if(/^Tono \d+$/.test(k))delete properties[k];});tones.forEach((t,n)=>properties['Tono '+(n+1)]=t);
    result=await post('cart/change.js',{id:line.key,quantity:line.quantity,properties,...sections()});
   }else{
    if(!Number.isInteger(count)||count<0||count>50)throw Error('Cantidad no válida.');
    const handle=config.units[lines[0].variant_id].handle,all=cart.items.filter(i=>i.properties?._rr_offer&&config.units[i.variant_id]?.handle===handle);
    const total=count+all.filter(i=>i.properties._rr_offer!==group&&i.properties._rr_role==='paid').reduce((s,i)=>s+i.quantity,0);
    const parts=count?split(lines[0].variant_id,total):null;
    if(parts&&!(all.length===2&&parts.length===1&&parts[0][0]===lines[0].variant_id)){result=await regroup(all,parts,group,count);await render(result);error('');return;}
    // Update both real lines in one Shopify request. Never leave a gift behind after removal.
    result=await post('cart/update.js',{updates:Object.fromEntries(lines.map(l=>[l.key,count])),...sections()});
    if(count&&config.units[lines[0].variant_id].colors.length){
     for(const old of lines){
      const current=(await read()).items.find(l=>l.properties?._rr_offer===group&&l.properties._rr_role===old.properties._rr_role);
      if(!current)throw Error('Recarga el carrito antes de continuar.');
      const properties={...current.properties};Object.keys(properties).forEach(k=>{if(/^Tono \d+$/.test(k))delete properties[k];});
      for(let n=0;n<count;n++)properties['Tono '+(n+1)]=old.properties['Tono '+(n+1)]||old.properties['Tono 1'];
      result=await post('cart/change.js',{id:current.key,quantity:count,properties,...sections()});
     }
    }
   }
   await render(result);error('');
  }catch(e){error(e.message);}finally{busy=false;checkout?.removeAttribute('disabled');}
 }
 document.addEventListener('click',e=>{const b=e.target.closest('[data-rr-bogo-adjust]');if(!b)return;e.preventDefault();e.stopImmediatePropagation();const row=b.closest('[data-rr-offer]');const n=Number(row.dataset.quantity);updateOffer(row.dataset.rrOffer,b.dataset.rrBogoAdjust==='remove'?0:n+Number(b.dataset.rrBogoAdjust));},true);
 document.addEventListener('change',e=>{const row=e.target.closest('[data-rr-offer]');if(!row)return;if(e.target.matches('[data-rr-bogo-quantity]')){e.stopImmediatePropagation();updateOffer(row.dataset.rrOffer,Number(e.target.value));}if(e.target.matches('[data-rr-bogo-tone]')){e.stopImmediatePropagation();updateOffer(row.dataset.rrOffer,null,row.dataset.role,[...row.querySelectorAll('[data-rr-bogo-tone]')].map(s=>s.value));}},true);
 // Existing customer carts are migrated only after the replacement units and their discounts are live.
 async function migrate(){
  const cart=await read();const old=cart.items.filter(i=>config.packs[i.variant_id]);if(!old.length)return;
  const checkout=document.querySelector('#CartDrawer-Checkout');checkout?.setAttribute('disabled','');
  try{
   for(const line of old){
    const group='legacy-'+line.key.replace(/[^a-z0-9]/gi,'');
    const now=await read();const source=now.items.find(i=>i.key===line.key);if(!source)continue;
    const existing=now.items.filter(i=>i.properties?._rr_offer===group);
    if(!existing.length)await post('cart/add.js',{items:expand(source.variant_id,source.quantity,source.properties,null,group)});
    const confirm=await read();const added=confirm.items.filter(i=>i.properties?._rr_offer===group);
    if(added.length!==2||added.some(i=>i.quantity!==config.packs[source.variant_id].count*source.quantity))throw Error('Actualiza el carrito para confirmar las cantidades.');
    await post('cart/change.js',{id:source.key,quantity:0});
   }
   await render(await read());
  }catch(e){error(e.message);throw e;}finally{checkout?.removeAttribute('disabled');}
 }
 document.addEventListener('DOMContentLoaded',()=>{migrate().catch(e=>console.warn('Rorilio BOGO:',e.message));});
})();
